import { NavItemLink, NavItems } from "@/components/ui/resizable-navbar";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { NavItem, NavModel } from "@/lib/navigation";
import { cn } from "@/lib/utils";
import { NavBadge } from "./NavBadge";

interface PrimaryNavProps {
  items: NavItem[];
  style: NavModel["primaryStyle"];
}

/** Az asztali fejléc linksávja a `NavModel.primary` elemeiből */
export function PrimaryNav({ items, style }: PrimaryNavProps) {
  const compact = style === "iconLabel";
  return (
    <TooltipProvider delay={300}>
      <NavItems aria-label="Fő navigáció">
        {items.map((item) => (
          <PrimaryNavLink key={item.path} item={item} compact={compact} />
        ))}
      </NavItems>
    </TooltipProvider>
  );
}

interface PrimaryNavLinkProps {
  item: NavItem;
  compact: boolean;
}

/**
 * `compact` (admin szekciók) módban a rendelkezésre álló helyhez igazodik: lg alatt csak ikon
 * (a címke tooltipben), lg–xl között csak felirat, xl-től ikon + felirat – így öt szekció sem
 * csordul túl 1024 px-en.
 */
function PrimaryNavLink({ item, compact }: PrimaryNavLinkProps) {
  const Icon = item.icon;
  const content = (
    <>
      {compact && <Icon className="size-4 lg:max-xl:hidden" aria-hidden="true" />}
      <span className={cn(compact && "max-lg:sr-only")}>{item.label}</span>
      {item.badge ? <NavBadge count={item.badge} /> : null}
    </>
  );

  if (!compact) {
    return (
      <NavItemLink to={item.path} end={item.end}>
        {content}
      </NavItemLink>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger render={<NavItemLink to={item.path} end={item.end} />}>{content}</TooltipTrigger>
      <TooltipContent side="bottom" className="lg:hidden">
        {item.label}
      </TooltipContent>
    </Tooltip>
  );
}
